/* sw-countdown — upgrades the server-rendered absolute drop time into a live tick.
   Added 2026-08-14.

   Design notes worth keeping:

   - Every tick recomputes from Date.now() against a FIXED target instead of
     decrementing a counter. A decrementing counter drifts (setInterval is not
     precise) and, worse, freezes while a mobile tab is backgrounded — the
     shopper returns to a clock that is minutes stale and still counting from
     where it stopped. Recomputing is self-correcting by construction.

   - The target is parsed from an ISO 8601 string WITH an offset, so the instant
     is absolute and a visitor in any timezone sees the same remaining time.

   - `pageshow` with event.persisted: iOS/Safari restore this page from BFCache
     with the JS heap intact, so the interval may be dead or the DOM stale after
     a Back navigation. This theme has been bitten by BFCache before (see the
     intakeFrozen note in the Shopify skill); resync on restore rather than
     trusting the timer survived.

   - An unparseable date hides the element rather than rendering "NaN". Liquid
     guards this too; both layers do it because either can be edited alone.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-sw-countdown]');
  if (!root) return;

  var clock = root.querySelector('[data-sw-clock]');
  if (!clock) return;

  var target = new Date(root.getAttribute('data-sw-deadline')).getTime();
  if (!isFinite(target)) {
    // Never leave a broken clock on the page.
    root.hidden = true;
    return;
  }

  var doneText = root.getAttribute('data-sw-done') || 'Live now';
  var timer = null;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function render() {
    var left = target - Date.now();

    if (left <= 0) {
      clock.textContent = doneText;
      root.setAttribute('data-sw-state', 'done');
      stop();
      return;
    }

    var s = Math.floor(left / 1000);
    var d = Math.floor(s / 86400);
    var h = Math.floor((s % 86400) / 3600);
    var m = Math.floor((s % 3600) / 60);
    var sec = s % 60;

    // Days are omitted entirely under 24h rather than shown as "00D" — the unit
    // only earns its space when it carries information. This shifts the line's
    // width once, at the 24h boundary, which is a better trade than a permanent
    // dead zero.
    clock.textContent =
      (d > 0 ? pad(d) + 'D ' : '') + pad(h) + 'H ' + pad(m) + 'M ' + pad(sec) + 'S';
  }

  function stop() {
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
  }

  function start() {
    stop();
    render();
    if (target - Date.now() > 0) timer = setInterval(render, 1000);
  }

  start();

  // Backgrounded tabs throttle or suspend timers; resync the moment we are
  // visible again so the first frame the shopper sees is already correct.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) start();
  });

  // BFCache restore (Back out of checkout, or the SMS opt-in link).
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) start();
  });
})();
